/**
 * WhatsApp service for opening WhatsApp with pre-filled messages
 */

/**
 * Open WhatsApp with a pre-filled message
 * Handles mobile (iOS/Android) and desktop differently
 * 
 * @param {string} phoneNumber - Phone number with country code (e.g., "5519994823795")
 * @param {string} message - Pre-filled message text
 */
export function openWhatsApp(phoneNumber, message) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  console.log('WhatsApp service:', { 
    isMobile, 
    isIOS, 
    userAgent: navigator.userAgent,
    phoneNumber 
  });
  
  if (isMobile) {
    // Mobile: try whatsapp:// first, fallback to wa.me
    const whatsappLink = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const fallbackLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    console.log('Opening WhatsApp app:', whatsappLink);
    
    // Try to open WhatsApp app
    window.location.href = whatsappLink;
    
    // Fallback to wa.me if WhatsApp app not installed (after 1 second)
    setTimeout(() => {
      console.log('Fallback to wa.me:', fallbackLink);
      window.location.href = fallbackLink;
    }, 1000);
  } else {
    // Desktop: use wa.me in new tab
    const waLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    console.log('Opening wa.me in new tab:', waLink);
    window.open(waLink, '_blank');
  }
}
